module.exports = __webpack_public_path__ + "img/Oraganize_your_Services.2a8b41a2.png";